module.exports = __webpack_public_path__ + "img/search.d8f81bfb.svg";